import React from "react";
import "../../layouts/Styles.css";
import { connect } from "react-redux";
import { capitalize, get } from "lodash";

const CategoryList = (props: any) => {
  const { categories, selectedCategoryId, onSelectCategory } = props;

  return (
    <div className="flex flex-col justify-start">
      <h2 className="text-base mb-4 font-semibold text-valhalla">
        Categories
      </h2>
      <ul className="mb-8 ml-2 space-y-3 text-left text-gray-500">
        {/* "All" option to clear the filter */}
        <li
          onClick={() => onSelectCategory?.(null)}
          className="flex items-center space-x-3 cursor-pointer group"
        >
          <div
            className={`w-2 h-2 rounded-full transition-colors ${
              selectedCategoryId === null ? "bg-valhalla" : "bg-gray-300 group-hover:bg-gray-400"
            }`}
          />
          <span
            className={`text-sm transition-colors ${
              selectedCategoryId === null
                ? "text-valhalla font-semibold"
                : "group-hover:text-gray-700"
            }`}
          >
            All
          </span>
        </li>

        {categories.map((item: any, index: number) => {
          const isSelected = selectedCategoryId === item.categoryId;
          return (
            <li
              key={index}
              onClick={() => onSelectCategory?.(isSelected ? null : item.categoryId)}
              className="flex items-center space-x-3 cursor-pointer group"
            >
              <div
                className={`w-2 h-2 rounded-full transition-colors ${
                  isSelected ? "bg-valhalla" : "bg-gray-300 group-hover:bg-gray-400"
                }`}
              />
              <div className="flex flex-row gap-1">
                <span
                  className={`text-sm transition-colors ${
                    isSelected
                      ? "text-valhalla font-semibold"
                      : "group-hover:text-gray-700"
                  }`}
                >
                  {capitalize(item.categoryName)}
                </span>
                <span className="text-sm text-gray-400">
                  {`(${get(item, "productCount", 0)})`}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default connect(
  (state: any) => ({
    categories: state.product.get("categories"),
  }),
  {}
)(CategoryList);
